<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入直播场次ID">
        </el-input>
      </el-col>
      <el-col :span="6" >
        <el-button icon="el-icon-search" @click="searchPageData">搜索</el-button>
        <el-button icon="el-icon-download" @click="exportSelectedData" alt="">下载</el-button>
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="total, prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
          ref="dataTable"
          :data="items"
          style="width: 100%"
      >
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="goodsId" label="商品ID">
        </el-table-column>
        <el-table-column prop="goodsTitle" label="商品标题"></el-table-column>
        <el-table-column prop="goodsCurrentPrice" label="商品标题"></el-table-column>
        <el-table-column prop="goodsSaleCount" label="商品销量"></el-table-column>
        <el-table-column prop="promotionPriceStr" label="券后价"></el-table-column>


        <el-table-column prop="liveId" label="直播间信息">
          <template slot-scope="scope">
            房间ID:{{ scope.row.liveId }} <br />
            直播间标题:{{ scope.row.roomTitle }} <br />
            直播地址:{{ scope.row.roomLink }} <br />
            开播时间 {{ scope.row.roomCreateTimeStr}} <br/>
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="主播信息">
          <template slot-scope="scope">
            UID:{{ scope.row.userId }} <br />
            昵称:{{ scope.row.userName }} <br />
            粉丝数:{{scope.row.userFansCount}}<br />
            <a target="blank" :href="scope.row.userAppProfileLink">个人主页</a><br />
          </template>
        </el-table-column>
        <el-table-column prop="shopId" label="店铺信息">
          <template slot-scope="scope">
            shopId: {{ scope.row.shopId }} <br />
            店铺名称:{{ scope.row.shopName }} <br />
            店铺链接:{{scope.row.shopLink}}<br />
          </template>
        </el-table-column>
        <el-table-column label="主播头像" width="100">
          <template slot-scope="scope">
            <img
                :src="scope.row.userAvatar"
                width="70"
                height="70"
                class="head_pic"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
export default {
  name: "diantaoLiveShevles",
  data() {
    return {
      items: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      crawlerVersionHour:null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    exportSelectedJustLiveRooms(){},
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&liveRoomId=" + this.keyword;
      }
      para += "&withGoods=1";

      window.open("/api/diantao/export/liveShevles?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";


      if (this.keyword !== "") {
        para += "&liveRoomId=" + this.keyword;
      }


      axios
          .get("/api/diantao/queryPageLiveShevles?page=" + pageNum + "&pageSize=50" + para)
          .then((content) => {
            if (content.data.status.code === 0) {
              console.log(content.data.data)
              _this.items = content.data.data.items;
              _this.totalItems = content.data.data.total;
            }
          });
    },
  },
  mounted() {
    if(this.$route.query.id){
      this.keyword = this.$route.query.id
    }
    this.loadItemInfo(1);
  },
};
</script>
